import Statistic from './Statistic';
import Countdown from './Countdown';
Statistic.Countdown = Countdown;
export default Statistic;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/statistic/index.js
// module id = 827
// module chunks = 0